import Modal, {ModalProps} from "../../../components/Modal";
import BigNumber from "bignumber.js";
import React, {useCallback, useMemo, useState} from "react";
import useFarms from "../../../hooks/useFarms";
import {getBalanceNumber, getFullDisplayBalance} from "../../../utils/formatBalance";
import ModalTitle from "../../../components/ModalTitle";
import ModalActions from "../../../components/ModalActions";
import Button from "../../../components/Button";
import TokenInput from "../../../components/TokenInput";


interface NotifyRewardAmount extends ModalProps {
    onConfirm: (amount: string) => void
    tokenName?: string
}



export const NotifyRewardAmountModel: React.FC<NotifyRewardAmount> = ({
                                                              onConfirm,
                                                              onDismiss,
                                                              tokenName = '',
                                                          }) => {
    const [val, setVal] = useState('');


    const [pendingTx, setPendingTx] = useState(false);




    const handleChange = useCallback(
        (e: React.FormEvent<HTMLInputElement>) => {
            setVal(e.currentTarget.value)
        },
        [setVal],
    );


    // @ts-ignore
    return (
        <Modal>
            <ModalTitle text={`Deposit ${tokenName} Tokens`}/>
            <TokenInput
                max={100000000000000}
                value={val}
                onSelectMax={() =>{}}
                onChange={handleChange}
                symbol={tokenName}
            />
            <ModalActions>
                <Button text="Cancel" variant="secondary" onClick={onDismiss}/>
                <Button
                    disabled={pendingTx}
                    text={pendingTx ? 'Pending Confirmation' : 'Confirm'}
                    onClick={async () => {
                        if (!val) return;
                        // setPendingTx(true);
                        onDismiss();
                        await onConfirm(val);
                        // setPendingTx(false);
                        onDismiss()
                    }}
                />
            </ModalActions>
        </Modal>
    );

};

